module.exports = __webpack_public_path__ + "static/media/tips3.9bf519f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips3.png
// module id = 425
// module chunks = 0